var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18172",
    "data-name": "Path 18172",
    d: "M21,18v3H19V18H17V15h6v3ZM5,18v3H3V18H1V15H7v3ZM11,6V3h2V6h2V9H9V6Zm0,5h2V21H11ZM3,13V3H5V13Zm16,0V3h2V13Z",
    transform: "translate(-1 -3)",
    fill: "#dcb209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.419ada9bedcc7bc1f7fbd9b55ce10f29.svg";
export { ForwardRef as ReactComponent };